
import { Component, Prop, Vue } from 'vue-property-decorator';
import api from '@/api';
import moment from 'moment';
import { Route } from 'vue-router';
import Swal from 'sweetalert2';
import ItemForm from './Form.vue';

const { otherPoint } = api;

@Component({
  components: { ItemForm },
})
export default class OtherPointActivityEdit extends Vue {
  @Prop() private id!: string;

  @Prop() private activityId!: string;

  private form = {
    title: null,
    subTitle: null,
    pic: null,
    url: null,
    startTime: null,
    endTime: null,
    isEnabled: null,
  };

  private loading: boolean = false;

  private async submit(form: any) {
    if (form) {
      this.loading = true;
      const { status } = await otherPoint.activityEdit(
        this.id,
        this.activityId,
        form,
      );
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '修改成功' });
        await this.$router.back();
      }
    }
  }

  private setForm(data: any) {
    this.form = data;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: OtherPointActivityEdit) => void) => void,
  ) {
    const { id, activityId } = to.params;
    const { data } = await otherPoint.activityGet(id, activityId);
    data.startTime = moment(data.startTime).format('YYYY-MM-DD');
    data.endTime = moment(data.endTime).format('YYYY-MM-DD');
    await next(async (vm) => {
      vm.setForm(data);
    });
  }
}
